import { Button } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import {
  AddProductButton,
  DeleteProductButton,
  EditProductButton,
  MoveProductButton,
} from "./index";

export const ProductsFooter = (): JSX.Element => {
  return (
    <>
      <div className="flex flex-row ">
        <AddProductButton />
        <HorizontalSpace size={11} />
        <MoveProductButton />
        {/*        <HorizontalSpace size={11} />
        <Button icon="copy">Копировать</Button>*/}
        <HorizontalSpace size={11} />
        <DeleteProductButton />
        <HorizontalSpace size={11} />
        <EditProductButton />
      </div>
    </>
  );
};
